import { FC } from "react";
import {
  ExcessAmountMethodOption,
  IncreaseOfShareCapitalForm,
} from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { NumberField } from "../common/commonComponents";
import { Alert } from "../../components-v2/Alert";
import { Checkbox } from "../../components-v2/Checkbox";
import { RadioButtonGroup } from "../../components-v2/RadioButton";
import { calculateExcessAmount } from "./debtContributionDomain";
import { Box, VBox } from "../../components-v2/Box";
import { CURRENCY_NOK } from "../../utils/currency";

import { useTranslation } from "../../stores/RootStoreContext";

import { InfoButton } from "../../components-v2/InfoButton";
import { MTextInput } from "../../components-v2/TextInput";

const DebtContribution: FC<{ form: IncreaseOfShareCapitalForm }> = observer(({ form }) => {
  const { t } = useTranslation();

  return (
    <>
      <VBox gap={"md"}>
        <VBox>
          <div className={"text-lg"}>
            <b>{t("subscriber.debtConversion")}</b>
          </div>
          <div className={"text-sm"}>{t("subscriber.debtConversion.info")}</div>
        </VBox>
        {form.activeSubscribers.map((subscriber, index) => (
          <VBox key={subscriber.shareholderId}>
            <Checkbox
              checked={subscriber.hasDebtContribution}
              onChange={() => form.toggleDebtContribution(index)}
              label={subscriber.nameField.inputValue}
            />
            {subscriber.hasDebtContribution && (
              <VBox marginLeft={"sm"}>
                <Box gap={"sm"} alignItems={"stretch"}>
                  <NumberField
                    prefix={CURRENCY_NOK}
                    disabled={!subscriber.hasDebtContribution}
                    field={subscriber.debtContributionTotalReceivableField}
                    label={t("subscriber.debtConversion.totalReceivableTowardsCompany")}
                  />

                  <NumberField
                    prefix={CURRENCY_NOK}
                    disabled={!subscriber.hasDebtContribution}
                    field={subscriber.debtContributionMaxAmountToBeConvertedField}
                    label={t("subscriber.debtConversion.amount")}
                  />
                </Box>
                <MTextInput label={{ key: "address" }} model={subscriber.address} />
              </VBox>
            )}
            {subscriber.isAmountError && (
              <Alert type={"error"} message={t("debtConversionMaxAmountIsGreaterThanTotal")} />
            )}
          </VBox>
        ))}

        {calculateExcessAmount(form.activeSubscribers) > 0 && (
          <>
            <div>
              {t("decisions.increaseShareCapitalAgainstCash.excessAmount")}
              <InfoButton infoText={t("dbot.debconversion.excess.amount")} />
            </div>
            <RadioButtonGroup<ExcessAmountMethodOption>
              name={"debtConversionExcessAmount"}
              onChange={(_, option) => form.setExcessAmountMethod(option)}
              options={form.excessAmountMethodOptions}
              disabled={form.isProjectLocked}
              idFn={(option) => option.value}
              selected={form.selectedExcessAmountMethod}
              labelFn={(option) => t(option.label)}
            />
          </>
        )}
      </VBox>
      <hr />
    </>
  );
});

export default DebtContribution;
